module.exports = __webpack_public_path__ + "static/media/whoweare-tab.6f2a76a8.png";